// @ts-check

/**
 * Expenses module stores the entries on the
 * expenses page
 */

import { api } from '@/api'

import {
  baseGetters,
  baseMutations,
  createBaseActions,
  createBaseState
} from '@/store/modules/entries/base'

const baseActions = createBaseActions({
  entryType: 'expenses'
})

const initExpenseState = () => ({
  ...createBaseState(),
  search: ''
})

const expenseMutations = {
  ...baseMutations,
  clearAllData: (state) => {
    Object.assign(state, { ...createBaseState(), search: '' })
  }
}

const expenseGetters = {
  ...baseGetters
}

export const expenseActions = {
  ...baseActions,

  markAsPaid({ commit }, { id, payload }) {
    return api
      .patch(`/expenses/${id}/mark-as-paid`, {
        amount: payload.amount,
        paid_date: payload.date
      })
      .then(({ data }) => {
        commit('updateEntry', { id, data })
      })
  },

  linkBankTransactionsToEntry({ commit }, { id, payload }) {
    const { bankTransactions } = payload
    const { amount } = payload

    if (amount && bankTransactions.length === 1) {
      bankTransactions[0].amount = amount
    }

    return api
      .put(`expenses/link`, {
        bank_transactions: bankTransactions,
        entry_id: id
      })
      .then(({ data }) => {
        commit('updateEntry', { id, data })
      })
  }
}

export const expenseModule = {
  namespaced: true,
  state: initExpenseState,
  getters: expenseGetters,
  mutations: expenseMutations,
  actions: expenseActions
}

export default expenseModule
